// Subset of ReportTicketGroupColumnName from ReportingService

export enum TicketGroupReportTableGroupingColumnId {
  TicketGroupId = 'ticketGroupId',
  DeliveryTypeName = 'deliveryTypeName',
  InHandDate = 'inHandDate',
  Section = 'section',
  SeatingRow = 'seatingRow',
  SeatFrom = 'seatFrom',
  SeatTo = 'seatTo',
  PreDeliveryStateName = 'preDeliveryStateName',
  OrderId = 'orderId',
  PurchaseOrderId = 'purchaseOrderId',
  InsertBy = 'insertBy',
  PurchaseOrderDate = 'purchaseOrderDate',
  BuyerUserId = 'buyerUserId',
  PurchaseOrderVendorName = 'purchaseOrderVendorName',
  EncryptedEmailAddress = 'encryptedEmailAddress',
  PurchaseCancellationDate = 'purchaseCancellationDate',
  PurchasePaymentStatusName = 'purchasePaymentStatusName',
  PurchasePaymentMethodTypeName = 'purchasePaymentMethodTypeName',
  PaymentMethodFullInfo = 'paymentMethodFullInfo',
  InternalNotes = 'internalNotes',
  IsConsignment = 'isConsignment',
  ListingNoteTexts = 'listingNoteTexts',
  EventId = 'eventId',
  LocalEventDateTime = 'localEventDateTime',
  EventName = 'eventName',
  VenueName = 'venueName',
  CityName = 'cityName',
  StateProvince = 'stateProvince',
  CountryName = 'countryName',
  PerformerName = 'performerName',
  TopLevelCategoryName = 'topLevelCategoryName',
  ParentCategoryName = 'parentCategoryName',
  EventStateName = 'eventStateName',
  TicketStatus = 'ticketStatus',
}

export enum TicketGroupReportTableValueColumnId {
  UnitCost = 'unitCost',
  TotalCost = 'totalCost',
  NumberOfTickets = 'numberOfTickets',
  SoldQuantity = 'soldQuantity',
  UnsoldQuantity = 'unsoldQuantity',
  Charges = 'charges',
  Credits = 'credits',
  SoldCost = 'soldCost',
  TotalNetProceeds = 'totalNetProceeds',
  PandL = 'pandL',
  Margin = 'margin',
}

export const TICKET_GROUP_REPORT_TABLE_FORMULA_COLUMNS: TicketGroupReportTableValueColumnId[] =
  Object.values(TicketGroupReportTableValueColumnId);
